import { useState } from "react";
import { MenuIcon } from "../../../assets";
import styles from "./style.module.css";
import { DropdownMenu } from "../dropdownMenu";

export const DropdownButton = () => {

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const handleMenuClick = () => {
      console.log("Menu Button Clicked");
      console.log(`Is drop down Open ${isDropdownOpen}`);
      setIsDropdownOpen(!isDropdownOpen);
    };

  return (
    <div onClick={handleMenuClick} className={styles.dropdownButton}>
      <MenuIcon onClick={handleMenuClick} className={styles.icon} />
      {isDropdownOpen && <DropdownMenu />}
    </div>
  );
};
